import type { AuthFormData, ValidationResult } from '../../types';

/**
 * Validation centralisée pour l'authentification
 * Suit les best practices de validation côté client
 */

/**
 * Valide le format d'un email
 */
export function validateEmail(email: string): string | null {
  if (!email.trim()) {
    return 'Veuillez entrer votre adresse e-mail';
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email.trim())) {
    return 'Veuillez entrer une adresse e-mail valide';
  }

  return null;
}

/**
 * Valide un mot de passe
 */
export function validatePassword(password: string): string | null {
  if (!password.trim()) {
    return 'Veuillez entrer un mot de passe';
  }

  if (password.length < 6) {
    return 'Le mot de passe doit contenir au moins 6 caractères';
  }

  return null;
}

/**
 * Valide la confirmation de mot de passe
 */
export function validatePasswordConfirmation(
  password: string,
  confirmPassword: string
): string | null {
  if (!confirmPassword.trim()) {
    return 'Veuillez confirmer votre mot de passe';
  }

  if (password !== confirmPassword) {
    return 'Les mots de passe ne correspondent pas';
  }

  return null;
}

/**
 * Validation complète d'un formulaire d'authentification
 */
export function validateAuthForm(
  data: AuthFormData,
  includeConfirmPassword = false
): ValidationResult {
  const errors: Record<string, string> = {};

  // Validation email
  const emailError = validateEmail(data.email);
  if (emailError) errors.email = emailError;

  // Validation password
  const passwordError = validatePassword(data.password);
  if (passwordError) errors.password = passwordError;

  // Validation confirmation si nécessaire
  if (includeConfirmPassword && data.confirmPassword !== undefined) {
    const confirmError = validatePasswordConfirmation(data.password, data.confirmPassword);
    if (confirmError) errors.confirmPassword = confirmError;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}
